import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html'
})

export class TabComponent {
  @Input('tabTitle') tabTitle: string;
  @Input() active = false;
  @Input() hidden = false;
}
